import http from '../config/http';
import { removePageLoadingAction, setPageLoadingAction } from '../layout/action';
import { devLog } from '../utils';
import store from './store';

export const FETCH_GET_API_LOADING = 'FETCH_GET_API_LOADING';
export const FETCH_GET_API_SUCCESS = 'FETCH_GET_API_SUCCESS';
export const FETCH_GET_API_FAILURE = 'FETCH_GET_API_FAILURE';
export const CLEAR_PAGE_API_DATA = 'CLEAR_PAGE_API_DATA';
export const UPDATE_PAGE_STATE = 'UPDATE_PAGE_STATE';

export const fetchApiLoadingAction = (key, init, apiMeta) => ({
  type: FETCH_GET_API_LOADING,
  key,
  payload: { init, apiMeta },
});

export const fetchApiSuccessAction = (key, payload, meta = null) => ({
  type: FETCH_GET_API_SUCCESS,
  key,
  payload,
  meta,
});

export const fetchApiFailureAction = (key, error) => ({
  type: FETCH_GET_API_FAILURE,
  key,
  error,
});

export const clearApiDataAction = (keys) => ({
  type: CLEAR_PAGE_API_DATA,
  payload: Array.isArray(keys) ? keys : [keys],
});

export const fetchGetApiData =
  ({ url, params, key, init = null, onData = null, onError = null, method = 'GET' }) =>
  async (dispatch) => {
    let data = {};
    try {
      dispatch(fetchApiLoadingAction(key, init, { url, method, params }));
      let resp = {};
      if (method === 'GET') {
        resp = await http.get(url, { params });
      } else if (method === 'POST') {
        resp = await http.post(url, params);
      }
      data = await resp.data;
      if (onData && typeof onData === 'function') {
        data = onData(data);
      }
      dispatch(fetchApiSuccessAction(key, data));
    } catch (e) {
      let { message } = e;
      if (onError && typeof onError === 'function') {
        message = onError(e);
      }
      dispatch(fetchApiFailureAction(key, message));
    }

    return data;
  };

export const reFetchReduxApiData = async ({ url, params, method = 'GET' }, key, dispatch) => {
  let data = {};
  try {
    dispatch(setPageLoadingAction());
    let resp = {};
    if (method === 'GET') {
      resp = await http.get(url, { params });
    } else if (method === 'POST') {
      resp = await http.post(url, params);
    }

    data = await resp.data;
    dispatch(fetchApiSuccessAction(key, data));
  } catch (e) {
    devLog(e);
  } finally {
    dispatch(removePageLoadingAction());
  }
  return data;
};

export const reduxRefetch = async (key) => {
  const { meta } = store.getState().page[key] || {};
  if (!meta) return;
  const { dispatch } = store;
  const { url, method, params } = meta;

  let data = {};
  try {
    let resp = {};
    if (method === 'GET') {
      resp = await http.get(url, { params });
    } else if (method === 'POST') {
      resp = await http.post(url, params);
    }

    data = await resp.data;

    dispatch(fetchApiSuccessAction(key, data, meta));
  } catch (e) {
    let { message } = e;
    dispatch(fetchApiFailureAction(key, message));
  }
  return data;
};
